var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useRef, useState } from "react";
import { isCypress, isLocalDev } from "../../utils";
export var useShape = function (_a) {
    var srcIdentifier = _a.srcIdentifier, assetUrl = _a.assetUrl, authSdk = _a.authSdk, skipShapeOnLoad = _a.skipShapeOnLoad, logger = _a.logger;
    var removeShapeScripts = useRef(function () { });
    var _b = __read(useState(skipShapeOnLoad
        ? "unloaded"
        : isLocalDev() || isCypress()
            ? "loaded"
            : "pending"), 2), shapeStatus = _b[0], setShapeStatus = _b[1];
    var loadShape = function (forceReloadShape) { return __awaiter(void 0, void 0, void 0, function () {
        var cleanup;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShapeStatus("pending");
                    return [4 /*yield*/, authSdk.prepareShape({
                            forceReload: forceReloadShape,
                            srcIdentifier: srcIdentifier,
                            assetUrl: assetUrl
                        })];
                case 1:
                    cleanup = (_a.sent()).cleanup;
                    removeShapeScripts.current = cleanup;
                    setShapeStatus("loaded");
                    return [2 /*return*/];
            }
        });
    }); };
    var unloadShape = function () {
        var _a;
        (_a = removeShapeScripts.current) === null || _a === void 0 ? void 0 : _a.call(removeShapeScripts);
        setShapeStatus("unloaded");
    };
    useEffect(function () {
        if (skipShapeOnLoad)
            return;
        var init = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, loadShape()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        logger === null || logger === void 0 ? void 0 : logger.error(new Error("Error loading shape. Reason: ".concat(error_1)), {
                            tags: {
                                componentName: "useShape",
                                featureName: "useShape",
                                functionName: "init"
                            }
                        });
                        setShapeStatus("failed");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skipShapeOnLoad]);
    return {
        shapeStatus: shapeStatus,
        loadShape: loadShape,
        unloadShape: unloadShape
    };
};
